import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import GospelHub from "./pages/hubs/GospelHub";
import IdentityHub from "./pages/hubs/IdentityHub";
import HermeneuticsHub from "./pages/hubs/HermeneuticsHub";
import ExegesisHub from "./pages/hubs/ExegesisHub";
import WhatNowHub from "./pages/hubs/WhatNowHub";
import ResourcesHub from "./pages/hubs/ResourcesHub";
import LeadersHub from "./pages/hubs/LeadersHub";
import "./App.css";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-pulse text-primary font-serif text-xl">Loading...</div>
      </div>
    );
  }
  
  return isAuthenticated ? children : <Navigate to="/login" />;
};

const AppContent = () => {
  return (
    <div className="min-h-screen bg-background">
      <ScrollToTop />
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Navbar />
      <main id="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/gospel" element={<GospelHub />} />
          <Route path="/identity" element={<ProtectedRoute><IdentityHub /></ProtectedRoute>} />
          <Route path="/hermeneutics" element={<HermeneuticsHub />} />
          <Route path="/exegesis" element={<ExegesisHub />} />
          <Route path="/what-now" element={<WhatNowHub />} />
          <Route path="/resources" element={<ResourcesHub />} />
          <Route path="/leaders" element={<LeadersHub />} />
        </Routes>
      </main>
      <Toaster position="top-right" />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
